// import hooks
import { useTranslation } from "react-i18next";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";

// import components
// import { Row, Col } from "react-bootstrap";

// import assets

// import data

const OrderItem = ({ item }) => {
    const [t] = useTranslation("global");
    const windowWidth = useWindowSize();
    return (
        <div className="order-item product-section-div" key={item.id}>
            <div className="flex-between-row">
                <p className="order-title ocean-p-700">
                    {item.items[0].name}{" "}
                    <span className="blue-txt">
                        {item.items.length > 1
                            ? `+ ${item.items.length - 1}`
                            : ""}
                    </span>
                </p>
                <p className="order-total ocean-p-700">{`${item.total} ${item.currancy}`}</p>
            </div>

            <div>
                <p className="ocean-p-700 ocean-p-grey">{`${t(
                    "account.order.date"
                )} ${item.details.time} ${item.details.date}`}</p>
            </div>

            <div
                className={`order-status-div ${
                    windowWidth >= 992
                        ? "flex-between-row"
                        : "flex-start-col-reverse"
                }`}
            >
                <div>
                    <p className="order-status-p flex-start-row ocean-p-700">
                        <span className="order-status-txt">
                            {t("account.order.order-status")}
                        </span>
                        <span
                            className={`order-status-status ${
                                item.details.condition == 1
                                    ? "green-txt"
                                    : "red-txt"
                            }`}
                        >
                            {item.details.condition == 1
                                ? t("account.order.complete")
                                : t("account.order.uncomplete")}
                        </span>
                    </p>
                </div>
                <div>
                    <p className="order-item-paymethod ocean-p-700">
                        {t("account.order.pay-method")} {item.details.payMethod}
                    </p>
                </div>
            </div>

            <div className="flex-end-row">
                <button className="ocean-btn">
                    {t("account.order.order-details")}
                </button>
            </div>
        </div>
    );
};

export default OrderItem;
